module.exports = __webpack_public_path__ + "img/IMG_0300_L_BlackMatted.6cc3a7bd.jpg";